export default __webpack_public_path__ + "static/media/8 a.1e8a7d97.png";